import React from "react";

const PasswordInputChecker = ({ inputPassword }) => {
	const passwordUpperCase = /[A-Z]/.test(inputPassword);
	const passwordLowerCase = /[a-z]/.test(inputPassword);
	const passwordWithNumber = /[0-9]/.test(inputPassword);
	const passwordSpecialCharacter = /[^A-Za-z0-9]/.test(inputPassword);
	const passwordLength = inputPassword.length >= 6;
	
	return (
		<>
			<div className="password_checker">
				{passwordUpperCase ? (
					<p>
						<span className="check">&#10004; &nbsp;</span>
						UpperCase
					</p>
				) : (
					<p>
						<span className="wrong">&#x2718; &nbsp;</span>
						UpperCase
					</p>
				)}
				{passwordLowerCase ? (
					<p>
						<span className="check">&#10004; &nbsp;</span>
						LowerCase
					</p>
				) : (
					<p>
						<span className="wrong">&#x2718; &nbsp;</span>
						LowerCase
					</p>
				)}
				{passwordWithNumber ? (
					<p>
						<span className="check">&#10004; &nbsp;</span>
						At least one digit
					</p>
				) : (
					<p>
						<span className="wrong">&#x2718; &nbsp;</span>
						At least one digit
					</p>
				)}
				{passwordSpecialCharacter ? (
					<p>
						<span className="check">&#10004; &nbsp;</span>
						At least one special character
					</p>
				) : (
					<p>
						<span className="wrong">&#x2718; &nbsp;</span>
						At least one special character
					</p>
				)}
				{passwordLength ? (
					<p>
						<span className="check">&#10004; &nbsp;</span>
						Minimum 6 Characters
					</p>
				) : (
					<p>
						<span className="wrong">&#x2718; &nbsp;</span>
						Minimum 6 Characters
					</p>
				)}
			</div>
		</>
	);
};

export default PasswordInputChecker;
